<div class="pageheader">
  <div class="page-title">
    <h1>Document Type Classifiers</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Format types log'">
        <app-change-log-link-entity type="DocumentTypeClassifier"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div class="xcontainer xcontainer-fixed">
  <div class="xrow">
    <div class="col-sm-12">
      <dx-data-grid #duplicateCheckGrid
        biz-grid
        [selection]='{ mode: "none" }'
        [dataSource]='documentTypeClassifiers'
        [bizHideSelectedRowsComponent]="true"
        [showResetButton]="true"
        (onEditingStart)="onEditingStart($event)"
        (onEditorPreparing)="onEditorPreparing($event)"
        (onRowValidating)="onRowValidating($event)"
        (onInitNewRow)="onInitNewRow($event)"
        (onRowInserting)="onRowInserting($event)"
        (onRowUpdating)="onRowUpdating($event)"
        (onRowRemoving)="onRowRemoving($event)"
        [bizEditRowOnDoubleClick]="true">

        <dxo-editing
          mode="popup"
          [allowAdding]="hasCreatePerm"
          [allowUpdating]="hasEditPerm"
          [allowDeleting]="hasDeletePerm">
          <dxo-popup title="Document Type Classifier" [showTitle]="true"></dxo-popup>

          <dxo-form [showRequiredMark]="true" requiredMark="*">
            <dxi-item caption="Document Type Classifier" itemType="group" [colCount]="2" [colSpan]="2">
              <dxi-item dataField="Name" [isRequired]="true"></dxi-item>
              <dxi-item dataField="DocumentTypeId" [isRequired]="true"></dxi-item>
              <dxi-item dataField="IdentificationTypeId"></dxi-item>
              <dxi-item dataField="DocumentConfigId"></dxi-item>
            </dxi-item>

            <dxi-item caption="Document Type Classifier Resolver" itemType="group" [colCount]="1" [colSpan]="1">
              <dxi-item dataField="DocumentTypeClassifierResolverId" [isRequired]="true"></dxi-item>
            </dxi-item>

            <dxi-item caption="Control Message In Resolver" itemType="group" [colCount]="1" [colSpan]="1">
              <dxi-item dataField="IsControlMessageInFlow"></dxi-item>
              <dxi-item dataField="ControlMessageInResolverArtifactId" [isRequired]="true"></dxi-item>
            </dxi-item>
          </dxo-form>
        </dxo-editing>

        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

        <dxi-column dataField="Name" caption="Name" dataType="string" [allowGrouping]="false" sortOrder="asc">
        </dxi-column>
        <dxi-column dataField="DocumentTypeId" caption="Document Type" dataType="string" cellTemplate="documentTypeViewer" editCellTemplate="documentTypeEditor" [setCellValue]="setDocumentConfigValue">
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getDocumentTypeFilterData(bizGridFiltervalues.getPropertyValues(this.documentTypeClassifiers, 'DocumentTypeId'), documentTypes)"/>
        </dxi-column>
        <dxi-column dataField="IdentificationTypeId" caption="Identification Type" cellTemplate="identificationTypeViewer" editCellTemplate="identificationTypeEditor">
          <dxo-lookup [dataSource]="identificationTypes" valueExpr="Id" displayExpr="Name"></dxo-lookup>
        </dxi-column>
        <dxi-column dataField="DocumentConfigId" caption="Document Config In" dataType="string" cellTemplate="documentConfigViewer" editCellTemplate="documentConfigEditor">
        </dxi-column>
        <dxi-column dataField="IsControlMessageInFlow" caption="Is Control Message In Flow" dataType="boolean" [allowFiltering]="false">
        </dxi-column>
        <dxi-column dataField="ControlMessageInResolverArtifactId" caption="Control Messsage In Resolver" dataType="string" editCellTemplate="controlMessageInResolverArtifactEditTemplate" [visible]="false">

        </dxi-column>
        <dxi-column dataField="DocumentTypeClassifierResolverId" caption="Document Type Classifier Resolver" dataType="string" cellTemplate="documentTypeClassifierResolverViewer" editCellTemplate="documentTypeClassifierResolverEditor">
          <dxo-header-filter [dataSource]="bizGridFiltervalues.getDocumentTypeClassifierResolverFilterData(bizGridFiltervalues.getPropertyValues(this.documentTypeClassifiers, 'DocumentTypeClassifierResolverId'), documentTypeClassifierResolvers)"/>
        </dxi-column>

        <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.documentTypeClassifiers, 'CreatedBy'))"></dxo-header-filter></dxi-column>
        <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
        <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.documentTypeClassifiers, 'UpdatedBy'))"></dxo-header-filter>   </dxi-column>
        <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

        <dxi-column type="buttons">
          <dxi-button name="edit"></dxi-button>
          <dxi-button name="delete"></dxi-button>
          <dxi-button text="Show Log"
            template="logTemplate"
            [visible]="hasShowLogPerm">
          </dxi-button>
        </dxi-column>

        <ng-container *dxTemplate="let cell of 'logTemplate'">
          <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="DocumentTypeClassifier" [id]="cell.data.Id"></app-change-log-link-entity>
          </app-change-log-link>
        </ng-container>

        <div *dxTemplate="let cellInfo of 'documentTypeClassifierResolverEditor'">
          <select class="form-control" [ngModel]="selectedDocumentTypeClassifierResolver" (ngModelChange)="onDocumentTypeClassifierResolverChanged($event, cellInfo)">
            <option [ngValue]="null">Select...</option>
            @for (item of documentTypeClassifierResolvers; track item) {
              <option
                [ngValue]="item.Id">
                {{item.Name}}
              </option>
            }
          </select>
          @if (documentTypeClassifierResolverDataFields.length > 0) {
            <ep-datafield-group-container [formValidationGroup]="documentTypeClassifierResolverFormGroup" [showError]="true" [datafieldGroups]="documentTypeClassifierResolverDataFields" [isAlwaysEditable]="true" [numberOfColumns]="2"></ep-datafield-group-container>
          }
        </div>

        <div *dxTemplate="let cellInfo of 'documentTypeClassifierResolverViewer'">
          <span>{{getDocumentTypeClassifierResolverName(cellInfo.data)}}</span>
        </div>

        <div *dxTemplate="let cellInfo of 'documentTypeEditor'">
          <select class="form-control" [ngModel]="selectedDocumentType" (ngModelChange)="onGenericValueChanged($event, cellInfo)">
            <option [ngValue]="null">Select...</option>
            @for (item of documentTypes; track item) {
              <option
                [ngValue]="item.Id"
                [title]="item.Description">
                {{item.Name}}
              </option>
            }
          </select>
        </div>

        <div *dxTemplate="let cellInfo of 'documentTypeViewer'">
          <span>{{getDocumentTypeName(cellInfo.data)}}</span>
        </div>

        <div *dxTemplate="let cellInfo of 'identificationTypeEditor'">
          <select class="form-control" [ngModel]="selectedIdentificationType" (ngModelChange)="onGenericValueChanged($event, cellInfo)">
            <option [ngValue]="null">Select...</option>
            @for (item of identificationTypes; track item) {
              <option
                [ngValue]="item.IdentificationTypeId"
                [title]="item.Description">
                {{item.Name}}
              </option>
            }
          </select>
        </div>

        <div *dxTemplate="let cellInfo of 'identificationTypeViewer'">
          <span>{{getIdentificationTypeName(cellInfo.data)}}</span>
        </div>

        <div *dxTemplate="let cellInfo of 'documentConfigEditor'">
          <select class="form-control" [ngModel]="selectedDocumentConfig" (ngModelChange)="onGenericValueChanged($event, cellInfo)">
            <option [ngValue]="null">{{documentConfigsToDisplay.length > 0 ? "Select..." : "No document configs for the currently selected document type..."}}</option>
            @for (item of documentConfigsToDisplay; track item) {
              <option
                [ngValue]="item.DocumentConfigId"
                [title]="item.Description">
                {{item.FormatName}} / {{item.VariantName}} / {{item.VersionName}}
              </option>
            }
          </select>
        </div>

        <div *dxTemplate="let cellInfo of 'documentConfigViewer'">
          <span>{{getDocumentConfigName(cellInfo.data)}}</span>
        </div>

        <ng-container *dxTemplate="let cellInfo of 'controlMessageInResolverArtifactEditTemplate'">
          <app-developer-artifact-assembly-picker
            [assemblyTypes]="['ControlMessageInResolver', 'ControlMessageInResolver2']"
            (selectedArtifactIdChange)="onControlMessageInResolverChanged($event, cellInfo)"
            [selectedArtifactId]="cellInfo.data.ControlMessageInResolverArtifactId"
            [isReadOnly]="disableControlMessageInFlowOptions"
            [clearSelected]="clearArtifactPickerCurrentSelection">
          </app-developer-artifact-assembly-picker>
          @if (controlMessageInResolverDataFields.length > 0) {
            <ep-datafield-group-container [formValidationGroup]="controlMessageInResolverFormGroup" [showError]="true" [datafieldGroups]="controlMessageInResolverDataFields" [isAlwaysEditable]="true" [numberOfColumns]="2"></ep-datafield-group-container>
          }
        </ng-container>
      </dx-data-grid>
    </div>
  </div>
</div>
